import { createRequestError } from '../Reducers/Option/Actions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { createRequest } from '../Api';
import get from 'lodash/get';

export const useComponentOptions = (componentIdentifier) => {
  const { configuration } = useSelector((state) => state.Configuration);
  const itemIdentifier = configuration.item?.identifier;
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!itemIdentifier) {
      return;
    }
    (async () => {
      const { request } = createRequest();
      try {
        const response = await request({
          method: 'post',
          url: `frontendapi/options/list/${itemIdentifier}/${componentIdentifier}?_channel=_default`,
          data: {
            configuration,
            configurationtype: 'user',
          },
        });
        const options = get(response, 'data', []);
        setOptions(options);
      } catch (e) {
        dispatch(createRequestError(e));
      }
    })();
  }, [itemIdentifier, componentIdentifier, dispatch]);
  return options;
};
